import { c as _c } from "react/compiler-runtime";
/**
 * `useMorfiAuth` — INTERNAL primitive. App code MUST NOT import this; use
 * `useAuth` (`./use-auth.ts`) — the single public application auth hook.
 *
 * This is the thin `useSyncExternalStore` read of the SDK-owned `auth-state`
 * store, factored out only so its two SDK-internal consumers — `useAuth`
 * (which layers on actions + the impersonation overlay) and
 * `useEngineerIdentity` — share one subscription instead of duplicating it.
 * It is not exported from any consumer barrel and is not a manifest hook.
 *
 * Layer note: `auth-state` holds the resolved *application* identity
 * (`MorfiUser`). The separate transport-credential layer (`anon`/`user`,
 * from the NATS jwt-store) is `useSdkCredentialKind` — a different concern.
 */
import { useSyncExternalStore } from 'react';
import { getSdkAuthStore } from './auth-state.js';
const SERVER_SNAPSHOT = Object.freeze({
  status: 'loading',
  user: null
});
/**
 * Live SDK auth state — `{ status, user }`. SSR renders `loading`/`null`
 * (auth is client-only); the client re-renders once session-restore
 * settles the store.
 */
export function useMorfiAuth() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getSdkAuthStore();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const store = t0;
  return useSyncExternalStore(store.subscribe, store.current, _temp);
}
function _temp() {
  return SERVER_SNAPSHOT;
}